import { GET, POST, POSTNEW, download, UPLOADINGNEW, uploading, POSTFormData,POSTFormDataNEW, EXPORTNEW, uploadingImg, DELETENEW, GETNEW } from '@/request/http'

// 勤工助学岗位分页
export const getProgramData = p => POSTNEW('/studentgrowthfiles/workStudyUnitPost/page', p)

// 勤工助学岗位按Id删除
export const deleteProgramData = p => POSTNEW('/studentgrowthfiles/workStudyUnitPost/deleteById', p)

// 勤工助学岗位创建计划
export const createdProgramPlan = p => POSTNEW('/studentgrowthfiles/workStudyUnitPost/insertOrUpdateInfo', p)

// 编辑计划
export const editProgramPlan = p => GETNEW('/studentgrowthfiles/workStudyUnitPost/getInfoById', p)

// 根据userId获取单位信息(用来岗位带信息)
export const getProgramUserId = p => GETNEW('/studentgrowthfiles/workStudyUnit/getInfoByUserId', p)

// 用工计划分页
export const getEmploymentPlan = p => POSTNEW('/studentgrowthfiles/workStudyPlan/page', p)

// 学工改变计划状态
export const changeProgramPlanStatus = p => POSTNEW('/studentgrowthfiles/workStudyPlan/updatePlanStatus', p)

// 用工计划详情分页
export const recruitProgramDeatailData = p => POSTNEW('/studentgrowthfiles/workStudyStudentWork/page', p)

// 用工计划详情删除学生
export const programDeatailDeleteData = p => POSTNEW('/studentgrowthfiles/workStudyStudentWork/deleteById', p)

// 用工计划详情根据登录人获取岗位列表
export const getprogramDeatailPostList = p => POSTNEW('/studentgrowthfiles/workStudyUnitPost/getInfoByUserId', p)

// 用工计划详情添加助学学生
export const addProgramStudent = p => POSTNEW('/studentgrowthfiles/workStudyStudentWork/insertStudyWorkStudent', p)

// 用工计划详情用工单位统计
export const getProgramStatistics = p => POSTNEW('/studentgrowthfiles/workStudyStudentWork/getStudentWorkStatic', p)

// 用工计划详情评价
export const programEvaluate = p => POSTNEW('/studentgrowthfiles/workStudyStudentWork/updateEvaluateById', p)

// 助学学生打卡记录分页查询
export const getClockingRecord = p => POSTNEW('/studentgrowthfiles/workStudyStudentClock/getPageWorkStudyStudentWork', p)

// 助学学生打卡补签
export const supplementSign = p => POSTNEW('/studentgrowthfiles/workStudyStudentClock/suppleSignature', p)

// 学工分页单位分页详情
export const getProgramStudentData = p => POSTNEW('/studentgrowthfiles/workStudyStudentWork/getPageByCollege', p)

// 学工计划进入页面统计接口
export const getProgramStudentStatisticsData = p => GETNEW('/studentgrowthfiles/workStudyStudentWork/getStaticByCollege', p)

// 学工分页单位分页详情
export const getProgramStudentDeatilData = p => POSTNEW('/studentgrowthfiles/workStudyStudentWork/pageCollege', p)

// 勤工俭学发送审批
export const sendProgramApproval = p => POSTNEW('/studentgrowthfiles/workStudySalaryApply/sendApproval', p)

// 用工单位工资发放申请
export const getProgramSalary = p => GETNEW('/studentgrowthfiles/workStudyStudentWork/getAppleInfo', p)

// 学工工资详情统计信息
export const  getProgramStudentWorkStatisticsData = p => GETNEW('/studentgrowthfiles/workStudyStudentWork/payInfo', p)

// 查询负责人
export const getChargePerson = p => POSTNEW('/studentgrowthfiles/workStudyUnit/page', p)

// 下载工作记录
export const workRecordsDownload = p => EXPORTNEW('/studentgrowthfiles/workStudyStudentWork/export', p)

// 下载学生名单
export const programStudentDownload = p => EXPORTNEW('/studentgrowthfiles/workStudyStudentWork/exportStudyWork', p)

// 一键发送短信
export const programSendSMS = p => POSTNEW('/studentgrowthfiles/workStudyStudentWork/sendMessage', p)

// 一键发送短信
export const programSendSMSByPlan = p => POSTNEW('/studentgrowthfiles/workStudyStudentWork/sendMessageByPlan', p)

// 工资申报表
export const programDownloadDeclarationForm = p => EXPORTNEW('/studentgrowthfiles/workStudyStudentWork/downloadExcel', p)

// 计划详情导入
export const importExportProgram = p => POSTFormDataNEW('/studentgrowthfiles/workStudyStudentWork/importStudentWorkInfo', p)

// 添加助学学生
export const getAddAllProgramStudent = p => POSTNEW('/studentv2/archives/page', p)

// 作废打卡记录
export const cancelProgramClockRecords = p => POSTNEW('/studentgrowthfiles/workStudyStudentClock/deleteById', p)

// 修改打卡记录
export const modifyProgramClockRecords = p => POSTNEW('/studentgrowthfiles/workStudyStudentClock/updateStudentClock', p)

// 用工单位校验接口
export const programCompanySendMessag = p => POSTNEW('/studentgrowthfiles/workStudyPlan/noApplySendMessage', p)

// 学工计划导出工资
export const exportWages = p => EXPORTNEW('/studentgrowthfiles/workStudyStudentWork/exportSalary', p)

// 学工计划导出学生工资
export const exportWagesByPlan = p => EXPORTNEW('/studentgrowthfiles/workStudyStudentWork/exportSalaryByDegreeId', p)

// 用工单位详情导出工资申报表
export const exportSalaryForm = p => EXPORTNEW('/studentgrowthfiles/workStudyStudentWork/export', p)

// 用工单位详情导入学生名单
export const importEmployersStudentList = p => POSTFormDataNEW('/studentgrowthfiles/workStudyStudentWork/importStudent', p)

// 用工单位详情导入学生打卡记录
export const importEmployersStudenClockRecords = p => POSTFormDataNEW('/studentgrowthfiles/workStudyStudentClock/importStudentClock', p)

// 岗位申请设置提交
export const submitJobApplySeting = p => POSTNEW('/studentgrowthfiles/workStudyApplyPost/update', p)

// 岗位申请设置回显
export const getJobApplySeting = p => GETNEW('/studentgrowthfiles/workStudyApplyPost/get/detail', p)

// 根据类型获取所有岗位
export const getAllPostByDegreeType = p => POSTNEW('/studentgrowthfiles/workStudyUnitPost/findUnitAndPost', p)

// 添加推荐学生分页
export const getRecommendTabelData = p => POSTNEW('/studentgrowthfiles/workStudyPostApplyInfo/page', p)

// 添加用工学生库分页
export const getLibraryTabelData = p => POSTNEW('/studentgrowthfiles/workStudyPastPostStudent/page', p)

// 用工单位雇佣申请
export const employStudentApply = p => POSTNEW('/studentgrowthfiles/workStudyUnitPost/sendPostApplyByCollegeId', p)

// 学工获取岗位
export const getProgramWorkDetailPost = p => GETNEW('/studentgrowthfiles/workStudyUnitPost/getListByUnitId', p)

// 开启/关闭 岗位
export const turnPostStatus = p => POSTNEW('/studentgrowthfiles/workStudyUnitPost/updateByStatus', p)

// 学工控制困难生看见岗位
export const turnDSViewPost = p => POSTNEW('/studentgrowthfiles/workStudyPlan/updateIsDifficult', p)


// WEBPACK FOOTER //
// ./src/api/modules/program.js